import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from './key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { shellStringResources, IViolation, Credential, IAttribute } from 'shell-models-lib';

export enum SupportedAuthTypes {
    MSI = 'MSI'
}

@Metamodel.model({
    name: 'AzureFunction',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureFunctionActivityLabel),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.AzureFunctionActivityLabel)
    ]
})
export class AzureFunctionLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly RESOURCEID: IAttribute;
    public static readonly FUNCTION_APP_URL: IAttribute;
    public static readonly FUNCTION_KEY: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_FunctionAppUrl,
        association: 'FUNCTION_APP_URL',
        templatable: true
    })
    public functionAppUrl?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_FunctionKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'FUNCTION_KEY',
        templatable: true,
        accepts: ['String']
    })
    public functionKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        association: 'RESOURCEID',
        templatable: true
    })
    public resourceId?: string;

    @Metamodel.attribute({})
    public authentication?: string;

    public isAuthRefMethodCredential?: boolean = false;
    public accountNameSelectionMethod?: string = 'azure';

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: AzureFunctionLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant
    })
    public tenant?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedservice: AzureFunctionLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (linkedservice &&
            linkedservice.isAuthRefMethodCredential &&
            !referencedCredential) {
            return [{
                context: linkedservice,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
